var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimpleActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11331_27820)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1D2129"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_11331_27820)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.72217,
    y: 2.22223,
    width: 35.5556,
    height: 35.5556,
    rx: 17.7778,
    fill: "#1D2129"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.27772,
    y: 2.77778,
    width: 34.4444,
    height: 34.4444,
    rx: 17.2222,
    stroke: "white",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11331_27820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5384 14.2031C12.4946 12.9767 13.575 11.8671 14.7868 11.8525C16.057 11.8525 17.3272 11.8525 18.5974 11.8525C19.8384 11.8963 20.8604 13.0497 20.8312 14.2761C22.1306 14.2761 23.43 14.2615 24.7293 14.2761C25.8973 14.3199 26.9193 15.3565 26.9339 16.5245C26.9339 19.6489 26.9339 22.7733 26.9339 25.8977C26.9193 26.8613 26.2185 27.7519 25.2987 28.0439C24.9337 28.1753 24.5249 28.1461 24.1453 28.1461C21.0356 28.1461 17.9258 28.1461 14.816 28.1461C13.6188 28.1461 12.5384 27.0803 12.5384 25.8831C12.5384 21.9849 12.5384 18.0867 12.5384 14.2031ZM14.816 15.9697C14.4218 16.0281 14.159 16.4223 14.1882 16.8165C14.1882 19.7511 14.1882 22.6711 14.1882 25.6057C14.1298 26.1021 14.597 26.5109 15.0788 26.4525C18.2032 26.4525 21.313 26.4525 24.4373 26.4525C24.9045 26.4817 25.2695 26.0437 25.2549 25.5911C25.2549 22.6711 25.2549 19.7511 25.2549 16.8165C25.2841 16.3785 24.9191 15.9113 24.4519 15.9405C21.24 15.9697 18.028 15.9405 14.816 15.9697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1299 17.5757C16.3635 17.5027 16.5971 17.5319 16.8307 17.5173C18.9769 17.5319 21.1231 17.5027 23.2693 17.5319C23.8386 17.5319 24.116 18.3787 23.6926 18.7437C23.4882 19.0065 23.1233 18.9627 22.8313 18.9627C20.6997 18.9481 18.5535 18.9773 16.4219 18.9481C15.6919 18.9773 15.4875 17.8677 16.1299 17.5757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1737 20.5248C16.3781 20.4372 16.6263 20.4664 16.8453 20.4518C18.9915 20.4664 21.1231 20.4372 23.2693 20.4664C23.7949 20.481 24.0869 21.1526 23.7949 21.576C23.6343 21.8534 23.2839 21.9556 22.9773 21.9264C20.7581 21.9264 18.5389 21.9556 16.3197 21.9264C15.6335 21.8096 15.5313 20.773 16.1737 20.5248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3051 23.4449C18.5243 23.3865 20.7581 23.4449 22.9919 23.4157C23.3715 23.3719 23.8095 23.5763 23.8825 23.9705C23.9993 24.4377 23.6051 24.9341 23.1233 24.8757C20.8749 24.8757 18.6411 24.8903 16.3927 24.8757C15.6043 24.8903 15.5021 23.5617 16.3051 23.4449Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11331_27820",
    x: 0.5,
    y: 0,
    width: 44.4444,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.44444
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.22222
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11331_27820"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_11331_27820",
    x: 2.72217,
    y: 2.22223,
    width: 40.0001,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.44444,
    dy: 4.44444
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.44444
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11331_27820"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11331_27820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7778,
    height: 17.7778,
    fill: "white",
    transform: "translate(11.0554 11.1119)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleActive);
export default __webpack_public_path__ + "static/media/simpleActive.eda9b8b301cb3ec3772a9160815207ed.svg";
export { ForwardRef as ReactComponent };